import { render } from "./result.vue?vue&type=template&id=6422edea&scoped=true"
import script from "./result.vue?vue&type=script&lang=js"
export * from "./result.vue?vue&type=script&lang=js"

import "./result.vue?vue&type=style&index=0&id=6422edea&lang=scss"
import "./result.vue?vue&type=style&index=1&id=6422edea&lang=scss&scoped=true"
import "./result.vue?vue&type=style&index=2&id=6422edea&lang=scss&scoped=true"

import exportComponent from "D:\\cm_zhitu\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6422edea"]])

export default __exports__